import { render, staticRenderFns } from "./WeeklyStoresHeader.vue?vue&type=template&id=5da4671c&lang=pug"
import script from "./WeeklyStoresHeader.vue?vue&type=script&lang=js"
export * from "./WeeklyStoresHeader.vue?vue&type=script&lang=js"
import style0 from "./WeeklyStoresHeader.vue?vue&type=style&index=0&id=5da4671c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports